<template>
  <div class="app" v-cloak>
    <transition name="fade" mode="out-in">
      <router-view/>
    </transition>
  </div>
</template>

<script>
  export default {
    name: 'App'
  }
</script>


<style lang="scss">
  @import '/assets/scss/_normalize';
  @import '/assets/scss/_include-media';
  @import '/assets/scss/_fonts';
  @import '/assets/scss/_variables';
  @import '/assets/scss/_typography';
  @import '/assets/scss/_base';
</style>



// WEBPACK FOOTER //
// src/App.vue